import type { AxiosPromise } from 'axios';
import axios from 'axios';
import { defineStore } from 'pinia';

import * as NoraApi from '@nora-monorepo/nora-api-client';

export const useApiStore = defineStore('apiStore', () => {
  const apiConfig = new NoraApi.Configuration();

  const admin = NoraApi.AdminsApiFactory(apiConfig, undefined, axios);
  const systemCheck = NoraApi.AdminSystemCheckApiFactory(apiConfig, undefined, axios);
  const consent = NoraApi.ConsentApiFactory(apiConfig, undefined, axios);
  const debug = NoraApi.DebugApiFactory(apiConfig, undefined, axios);
  const event = NoraApi.EventApiFactory(apiConfig, undefined, axios);
  const push = NoraApi.PushApiFactory(apiConfig, undefined, axios);
  const file = NoraApi.FileApiFactory(apiConfig, undefined, axios);
  const nexus = NoraApi.NexusApiFactory(apiConfig, undefined, axios);
  const nexusGroup = NoraApi.NexusGroupApiFactory(apiConfig, undefined, axios);
  const sync = NoraApi.SyncApiFactory(apiConfig, undefined, axios);
  const nexusOperation = NoraApi.NexusOperationApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const nexusOperationConversation
    = NoraApi.NexusOperationConversationApiFactory(apiConfig, undefined, axios);
  const nexusUser = NoraApi.NexusUserApiFactory(apiConfig, undefined, axios);
  const nexusRole = NoraApi.NexusAccessRoleApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const nexusPermission = NoraApi.NexusAccessPermissionApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const nexusSearch = NoraApi.NexusSearchApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const settings = NoraApi.SettingsApiFactory(apiConfig, undefined, axios);
  const userNotifications = NoraApi.UserNotificationsApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const deviceRegistration = NoraApi.DeviceRegistrationApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const conversation = NoraApi.ConversationApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const conversationMessage = NoraApi.ConversationMessageApiFactory(
    apiConfig,
    undefined,
    axios,
  );
  const conversationMessageAttachment
    = NoraApi.ConversationMessageAttachmentApiFactory(
      apiConfig,
      undefined,
      axios,
    );
  const chatSearch = NoraApi.ChatSearchApiFactory(apiConfig, undefined, axios);
  const drawLayerAdmin = NoraApi.DrawLayerAdminApiFactory(apiConfig, undefined, axios);
  const drawLayerOperation = NoraApi.DrawLayerOperationApiFactory(apiConfig, undefined, axios);
  const drawLayer = NoraApi.DrawLayerApiFactory(apiConfig, undefined, axios);
  const geo = NoraApi.GeoApiFactory(apiConfig, undefined, axios);
  const webView = NoraApi.WebViewApiFactory(apiConfig, undefined, axios);
  const geofence = NoraApi.GeofenceApiFactory(apiConfig, undefined, axios);
  const symbol = NoraApi.SymbolsApiFactory(apiConfig, undefined, axios);
  const tracker = NoraApi.TrackerApiFactory(apiConfig, undefined, axios);
  const trackerTemplate = NoraApi.TrackerTemplateApiFactory(
    apiConfig,
    undefined,
    axios,
  );

  const updateBasePath = (newBasePath: string): void => {
    apiConfig.basePath = newBasePath;
  };

  const unwrap = async <T extends NoraApi.ApiResult>(
    request: AxiosPromise<T>,
  ): Promise<T> => {
    const response = await request;

    if (!response) {
      throw new Error('No data returned');
    }

    const result = response.data;

    if (!result) {
      throw new Error('No data returned');
    }

    return response.data;
  };

  return {
    admin,
    systemCheck,
    consent,
    debug,
    event,
    push,
    file,
    geofence,
    settings,
    nexus,
    nexusGroup,
    sync,
    nexusOperation,
    nexusOperationConversation,
    nexusRole,
    nexusUser,
    nexusSearch,
    nexusPermission,
    userNotifications,
    deviceRegistration,
    chatSearch,
    conversation,
    conversationMessage,
    conversationMessageAttachment,
    drawLayer,
    drawLayerAdmin,
    drawLayerOperation,
    geo,
    webView,
    symbol,
    tracker,
    trackerTemplate,
    unwrap,
    updateBasePath,
  };
});
